import { render, staticRenderFns } from "./SongList.vue?vue&type=template&id=0bdc214c&scoped=true"
import script from "./SongList.vue?vue&type=script&lang=ts"
export * from "./SongList.vue?vue&type=script&lang=ts"
import style0 from "./SongList.vue?vue&type=style&index=0&id=0bdc214c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc214c",
  null
  
)

export default component.exports